<template>
  <div style="height: auto;padding-bottom:10px;">
    <NBar title="在线支付分析" :top="true"/>
    <div class="top">
      <nut-scroller class="time-more">
        <div slot="list" @click="timeItemClick(index)"
             :style="{backgroundColor:timeSelect === item.label ? '#ffffff' : '#e9e9e9',
             border:timeSelect === item.label ? '1px solid #194fff' : '1px solid #e9e9e9',
             color:timeSelect === item.label ? '#194fff' : '#a1a5ab'}"
             class="time-item" v-for="(item ,index) in timeList" :key="index">{{item.value}}
        </div>
      </nut-scroller>
    </div>
    <div class="card">
      <div style="margin: 0 10px;color: #9B9B9B; font-size: 14px;display:flex;">收益概况</div>
      <div style="margin: 0 10px;color: #9B9B9B; font-size: 16px;display:flex;justify-content: center;">在线收益</div>
      <div style="margin: 5px 10px 0 10px;display: flex; align-items: center; flex-direction: column;">
        <nut-price :price="data.onlinePayMoney" style="zoom: 1.7;" :decimalDigits="2" :needSymbol="true"
                   :thousands="true"/>
        <span v-if="data.onlineMoneyTrends === 0"
              style="color: #1afa29;margin-top: 5px;">较上周-{{data.onlinePayMoneyPer||0.00}}%</span>
        <span v-if="data.onlineMoneyTrends === 1"
              style="color: #d81e06;margin-top: 5px;">较上周+{{data.onlinePayMoneyPer||0.00}}%</span>
        <div style="height: 1px;background-color: #F5F6F8;width:100%;margin: 20px 0 10px 0;"></div>
      </div>
      <div style="display: flex;align-items: center;justify-content: center;">
        <div style="flex: 1;display: flex;flex-direction: column;justify-content: center;text-align: center;">
          <span style="color: #9B9B9B;">交易笔数</span>
          <span style="font-weight: bold;margin: 3px 0;">{{data.orderNum||0}}笔</span>
          <span v-if="data.orderNumTrends === 0"
                style="color: #1afa29;">-{{data.orderNumPer||0}}笔</span>
          <span v-if="data.orderNumTrends === 1"
                style="color: #d81e06;">+{{data.orderNumPer||0}}笔</span>
        </div>
        <div style="width: 1px;height: 40px;background-color: #F5F6F8;"></div>
        <div style="flex: 1;display: flex;flex-direction: column;justify-content: center;text-align: center;">
          <span style="color: #9B9B9B;">单笔均价</span>
          <nut-price :price="oneMoneyAvg()" style="margin: 3px 0;zoom: 0.9;" :decimalDigits="2"
                     :needSymbol="true"
                     :thousands="true"/>
          <span v-if="data.onlineMoneyTrends === 0"
                style="color: #1afa29;margin-top: 5px;">-{{oneMoneyPer()}}%</span>
          <span v-if="data.onlineMoneyTrends === 1"
                style="color: #d81e06;margin-top: 5px;">+{{oneMoneyPer()}}%</span>
        </div>
        <div style="width: 1px;height: 40px;background-color: #F5F6F8;"></div>
        <div style="flex: 1;display: flex;flex-direction: column;justify-content: center;text-align: center;">
          <span style="color: #9B9B9B;">顾客人数</span>
          <span style="font-weight: bold;margin: 3px 0;">{{data.countUserNum||0}}人</span>
          <span v-if="data.userTrends === 0" style="color: #1afa29;">-{{data.userNumPer||0}}人</span>
          <span v-if="data.userTrends === 1" style="color: #d81e06;">-{{data.userNumPer||0}}人</span>
        </div>
      </div>
    </div>
    <div class="card">
      <div style="margin: 0 10px;color: #9B9B9B; font-size: 14px;display:flex;align-items: center;">顾客构成<img
        @click="helpShow = true"
        :src="require('../../../resource/img/device/svg/help.svg')"
        style="width: 18px;height: 18px;margin-left: 10px;">
      </div>
      <nut-dialog title="客户构成" :visible="helpShow" ok-btn-txt="我知道了" @ok-btn-click="helpShow=false" no-cancel-btn
                  @close="helpShow=false">
        <div style="text-align: left;">
          <p>新顾客: 某天初次购买商品或消费的用户</p>
          <p>老用户: 某天不止一次购买商品或者消费的用户</p>
        </div>
      </nut-dialog>
      <div style="margin: 0 10px;color: #9B9B9B; font-size: 16px;display:flex;justify-content: center;">顾客人数</div>
      <div style="margin: 5px 10px 0 10px;display: flex; align-items: center; flex-direction: column;">
        <div><span style="font-size: 24px;">{{data.countUserNum||0}}</span><span>人</span></div>
        <span v-if="data.userTrends === 0" style="color: #1afa29;margin-top: 5px;">较上周-{{data.userNumPer||0}}人</span>
        <span v-if="data.userTrends === 1" style="color: #d81e06;margin-top: 5px;">较上周-{{data.userNumPer||0}}人</span>
        <div style="height: 1px;background-color: #F5F6F8;width:100%;margin: 20px 0 10px 0;"></div>
      </div>
      <div style="display: flex;align-items: center;justify-content: center;">
        <div style="flex: 1;display: flex;flex-direction: column;justify-content: center;text-align: center;">
          <span style="color: #9B9B9B;">新顾客数</span>
          <span style="font-weight: bold;margin: 3px 0;">{{data.userNum||0}}人</span>
        </div>
        <div style="width: 1px;height: 40px;background-color: #F5F6F8;"></div>
        <div style="flex: 1;display: flex;flex-direction: column;justify-content: center;text-align: center;">
          <span style="color: #9B9B9B;">老顾客数</span>
          <span style="font-weight: bold;margin: 3px 0;">{{data.oldUserNum||0}}人</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 支付分析
 */
export default {
  name: 'PayAnalysis',
  props: ['timeIndex'],
  data () {
    return {
      //当前选择时间索引
      timeSelect: 0,
      timeList: [],
      //说明弹窗
      helpShow: false,
      data: {}
    }
  },
  created () {
    let date = new Date()
    for (let i = 0; i < 7; i++) {
      let day = date.getDate()
      date.setDate(day - i)
      let dateStr1 = this.$util.formatDate.format(date, 'MM/dd')
      dateStr1 = dateStr1.replace(/-/g, '/')
      let dateStr2 = this.$util.formatDate.format(date, 'yyyy/MM/dd')
      dateStr2 = dateStr2.replace(/-/g, '/')
      let items = {
        label: i,
        value: dateStr1,
        date: dateStr2
      }
      if (i === 0) {
        items.value = '昨天'
      }
      this.timeList.push(items)
    }
  },
  activated () {
    let timeIndex = this.timeIndex || 0
    this.timeSelect = Number(timeIndex)
    this.getData()
  },
  methods: {
    getData () {
      let date = this.timeList[this.timeSelect].date
      date = date.replace(/-/g, '/')
      let startTime = new Date(date + ' 00:00:00')
      let endTime = new Date(date + ' 23:59:59')
      let data = {
        startTime: startTime.getTime() / 1000,
        endTime: endTime.getTime() / 1000
      }
      if (!this.$util.isArrOrNull(this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      this.$api.post({
        url: '/device/api/device/order/data-analysis',
        data: data,
        loading: false
      }).then(res => {
        this.data = res.data
      })
    },
    //日期快捷选择
    timeItemClick (index) {
      this.timeSelect = index
      this.getData()
    },
    oneMoneyAvg () {
      let onlinePayMoney = this.data.onlinePayMoney
      let orderNum = this.data.orderNum
      if (onlinePayMoney <= 0 || orderNum <= 0) {
        return 0
      }
      return onlinePayMoney / orderNum
    },
    oneMoneyPer () {
      let onlinePayMoneyPer = this.data.onlinePayMoneyPer
      let orderNum = this.data.orderNum
      if (onlinePayMoneyPer <= 0 || orderNum <= 0) {
        return 0
      }
      return (onlinePayMoneyPer / orderNum) * this.data.orderNumPer
    }
  }
}
</script>

<style scoped>
  >>> .nut-dialog-btn:only-child {
    color: #1a87ff;
  }

  >>> .nut-dialog-ok:active {
    background: #1a87ff;
    color: white;
  }

  .top {
    display: flex;
    flex-direction: column;
    background-color: white;
  }

  .top .time-more {
    margin: 10px 0;
  }

  .top .time-more .time-item {
    font-size: 14px;
    background-color: #e9e9e9;
    border: 1px solid #e9e9e9;
    color: #a1a5ab;
    border-radius: 5px;
    width: 50px;
    text-align: center;
    padding: 4px 3px;
    margin-left: 10px;
  }

  .card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: white;
    border-radius: 7px;
    padding: 5px 0 10px 0;
    margin: 15px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/home/PayAnalysis.vue